import FormLogin from '../components/Login/FormLogin'

export default function Login() {
  return (
    <FormLogin />
  )
}
